export const mutation_add_user = `
mutation addUser($userId: String!, $username: String!, $email: String!, $name: String!, $surname: String!, $locale: String!, $isRespAntiRic: Boolean!, $isActive: Boolean!, $isDeleted: Boolean!, $isBanned: Boolean!, $createdOn: timestamptz, $cf: String, $lastVersion : String, $emailTsId: String) {
    insert_user_one(object: { UserId: $userId, Username: $username, Email: $email, Name: $name, Surname: $surname, Locale: $locale, IsRespAntiRic: $isRespAntiRic, IsActive: $isActive, IsDeleted: $isDeleted, IsBanned: $isBanned, CreatedOn: $createdOn, Cf: $cf, LastVersion : $lastVersion, EmailTsId: $emailTsId }) {
        UserId
        Username
        Email
        Name
        Surname
        Locale
        IsRespAntiRic
        IsActive
        IsDeleted
        IsBanned
        CreatedOn
        Cf
        LastVersion
        EmailTsId
        user_tenants {
            TenantId
            Type
            TenantTipoId
            base_tipo_tenant {
            Value
            }
        }
    }
}`;
export const mutation_update_user_resetRespAntiRic = `
mutation resetRespAntiRic($tenantId: String!) {
    update_user(where: {
        user_tenants: {TenantId: {_eq: $tenantId}}}, 
        _set: {IsRespAntiRic: false}) {
        affected_rows
    }
}`;
export const mutation_update_user = `
mutation updateUser($tenantId: String!, $userId: String!, $name: String!, $surname: String!, $isRespAntiRic: Boolean!, $isActive: Boolean!, $isDeleted: Boolean!, $isBanned: Boolean!, $createdOn: timestamptz, $cf: String, $lastVersion : String, $emailTsId: String) {
    update_user(where: {
        user_tenants:{TenantId: {_eq: $tenantId}, UserId: {_eq: $userId}}},
            _set: {
                Name: $name, Surname: $surname, IsRespAntiRic: $isRespAntiRic, IsActive: $isActive, IsDeleted: $isDeleted, IsBanned: $isBanned, CreatedOn: $createdOn, Cf: $cf, LastVersion : $lastVersion, EmailTsId: $emailTsId
            }) {
                returning {
                    UserId
                    Username
                    Email
                    Name
                    Surname
                    Locale
                    IsRespAntiRic
                    IsActive
                    IsDeleted
                    IsBanned
                    CreatedOn
                    Cf
                    LastVersion
                    EmailTsId
                    user_tenants {
                    TenantId
                    Type
                    TenantTipoId
                    base_tipo_tenant {
                        Value
                    }
                }
            }
        }
    }`;